// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** New Caledonia */
const NC: PhoneNumberData = [687, 'NC', 6, '00.00.00'];

export default NC;
